module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("I should like to thank: Dave Freeman, an inspirational English teacher whose passion for literature has remained with me throughout my teaching career; John Thomason, a true gentleman who first encouraged me to offer classroom management training; Bob Isaac with whom I have worked collaboratively and creatively for over thirty years and whose stories of classroom management faux pas have made me laugh until my sides ached; Maggie McMurray, colleague and friend with whom I have shared numerous cups of Earl Grey tea whilst we have watched, amazed, at the machinations and ineptitudes of some aspects of the educational system; Jill Eatherden, colleague and friend with whom I joint-taught probably the worst lesson of both of our lives; Liz, my wife who has loved and supported me throughout my career and our sons, Chris and Alex, without whom all of this would be dust.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 81
// module chunks = 0